import { render, staticRenderFns } from "./SignUpType.vue?vue&type=template&id=788c876a&"
import script from "./SignUpType.vue?vue&type=script&lang=js&"
export * from "./SignUpType.vue?vue&type=script&lang=js&"
import style0 from "./SignUpType.vue?vue&type=style&index=0&id=788c876a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports